import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBGfshrpchFXc6yGW2DgMlNgmtoIU4MYcA",
  authDomain: "blade-app-ce841.firebaseapp.com",
  projectId: "blade-app-ce841",
  storageBucket: "blade-app-ce841.firebasestorage.app",
  messagingSenderId: "944231135390",
  appId: "1:944231135390:web:417a980797a3ef5482e38f"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);